import api, { setHeaderToken, removeHeaderToken } from "../../../apis/Api";

import router from "@/router";
import { allMixin } from "@/mixins/allMixin.js";
import { testElement } from "domutils";

export default {
  namespaced: true,
  state: {
    myRequest: [],
    userLog: []
  },
  getters: {
    getMyRequest(state) {
      return state.myRequest;
    },
    getUserLog(state) {
      return state.userLog;
    }
  },
  mutations: {
    setMyRequest(state, payload) {
      state.myRequest = payload;
    },
    setUserLog(state, payload) {
      state.userLog = payload;
    }
  },
  actions: {
    getMyRequest({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: `dashboard/request`,
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(res => {
          if (res.respond.status == "success") {
            commit("setMyRequest", res.respond.data);
          } else if (res.respond.status == "forbidden") {
            allMixin.methods.removeSession()
            router.push(`/login`).catch(() => {});
          }
          dispatch("setLoading", false);
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },
    getUserLog({ state, commit, dispatch, rootGetters }, payload) {
      // dispatch('setLoading', true)
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: `dashboard/usersign`,
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(res => {
          if (res.respond.status == "success") {
            commit("setUserLog", res.respond.data);
          } else if (res.respond.status == "forbidden") {
            allMixin.methods.removeSession()
            router.push(`/login`).catch(() => {});
          }
          // dispatch('setLoading', false)
        })
        .catch(err => {
          console.log("authjs=err" + err);
          // dispatch('setLoading', false)
          return false;
        });
    },

    setLoading({ commit }, payload) {
      commit("loader/setLoading", payload, {
        root: true
      });
    }
  }
};
